import { render, staticRenderFns } from "./MainNavigationBar.vue?vue&type=template&id=61f3430e&scoped=true&"
import script from "./MainNavigationBar.vue?vue&type=script&lang=js&"
export * from "./MainNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationBar.vue?vue&type=style&index=0&id=61f3430e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3430e",
  null
  
)

export default component.exports